<template>
    <div>
        <div v-if="is_on" id="spinner">
            <svg class="dot-spin" viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
            </svg>
        </div>
        <div id="spinner-stop">
            <div class="saved-msg-wrapper">
                <div class="checkmark draw"></div>
                <div class="saved-loader-text"> {{ $t('components.general.data_loader.saved') }} </div>
            </div>
        </div>
    </div>
</template>
<script>
import gsap from 'gsap';
import $ from 'jquery';

export default {
    props:['is_on',"is_saving"],
    watch:{
        is_on:function(){
            if (this.is_saving && !this.is_on) {
                // gsap.to('#spinner-stop', 0, { display: 'block' })
                // gsap.to('.checkmark', 0, { display: 'block' })
                // gsap.to('.saved-loader-text', 0, { display: 'block' })
                $('#spinner-stop').toggle()
                $('.checkmark').toggle()
                $('.saved-loader-text').toggle()
                setTimeout(() => {
                    $('#spinner-stop').toggle()
                    $('.checkmark').toggle()
                    $('.saved-loader-text').toggle()
                }, 3000);
            }
        }
    }
}
</script>
